import { GameType as CommonGameType } from '@/models/games/enums/GameType';
import { getBetGame } from '@/modules/bet/game/slice';
import { betRoomSliceActions } from '@/modules/bet/room/slice';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { getGameState } from '@/modules/games/selector';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { batch } from 'react-redux';
import type { Action, Dispatch } from 'redux';
import { getHostByGameId } from '../../../modules/host/slice';
import store from '../../../store/store';
import { GameState } from '../../games/enums/GameState';
import { CMDScStartGame, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScStartGameHandler extends AbstractHandler {
    _command: CMDScStartGame;

    constructor(command: ICommand) {
        super();
        this._command = command as CMDScStartGame;
    }

    override handle(dispatch: Dispatch<Action>): void {
        const gameId = this._command.GameID;
        const state = store.getState();
        const host = getHostByGameId(state, gameId);
        if (host) {
            const { isAutoConfirm } = getGameState(state);
            let _isAutoBet = isAutoConfirm;
            if (host.GameType === CommonGameType.Blackjack) {
                _isAutoBet = false;
            }
            console.log(`hook::socket::run::${host.HostId}`, this._command);
            if (host.GameType === CommonGameType.Blackjack) {
                const betGame = getBetGame(state, gameId);
                if (betGame !== undefined) {
                    const bets = betGame.bets;
                    for (const b of bets) {
                        dispatch(betRoomSliceActions.bet(b));
                    }
                }
            }
            batch(() => {
                dispatch(
                    hostLiveSliceActions.updateGameState({
                        hostId: host.HostId,
                        state: GameState.Started,
                    })
                );
                if (!_isAutoBet) {
                    dispatch(
                        tableBetSliceActions.clearPendingBets({
                            hostId: host.HostId,
                            gameId: this._command.GameID,
                            startGame: true,
                        })
                    );
                }
            });
        } else {
            console.warn('hook::socket::warning::cannot::find::host', gameId);
        }
    }
}
